














import { Vue, Component, Prop } from 'vue-property-decorator';
import Modal from '@/components/common/Modal.vue';

@Component({
  name: 'maintenance-modal',
  components: { Modal },
})
export default class MaintenanceModal extends Vue {
  @Prop({ default: true }) readonly modalOpen!: boolean;
}
